module.exports = __webpack_public_path__ + "static/media/neqasha.b6cba40b.jpg";